import { Component, EventEmitter, Output, OnInit, Input, TemplateRef } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable, combineLatest, map } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';
import { getQualtricsUrl } from '@fcom/common/qualtrics/qualtrics.utils';
import { ButtonMode, ButtonTheme, IconPosition } from '@fcom/ui-components';

@Component({
  selector: 'fin-bound-selection-error-message',
  templateUrl: 'bound-selection-error-message.component.html',
  standalone: false,
})
export class BoundSelectionErrorMessageComponent implements OnInit {
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;
  readonly ButtonMode = ButtonMode;

  @Input() fromFragment: TemplateRef<any>;

  @Input({ required: true }) ctaButtonText: string;

  @Input() enableSurvey = true;

  @Input() qualtricsKey = 'feedback.generalSurveyUrl';

  @Input() surveyButtonText = 'feedback.title';

  /**
   * Emits when the CTA element has been clicked
   * @type {EventEmitter}
   */
  @Output()
  ctaClick: EventEmitter<any> = new EventEmitter();

  qualtricsUrl$: Observable<string>;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.qualtricsUrl$ = combineLatest([
      this.languageService.langKey,
      this.languageService.translate(this.qualtricsKey),
    ]).pipe(
      map((params) => {
        return getQualtricsUrl(params[0], this.languageService.langValue, params[1]);
      })
    );
  }
}
